// extracted by mini-css-extract-plugin
export default {"main":"Paso1_main__ICN00","button":"Paso1_button__XrOHq","title":"Paso1_title__z+iMj"};